import { Repeat } from 'lucide-react';

import { Badge } from '@mokoboko/components';
import { mergeClassNames } from '@/lib/utils';

export const SubstituteBadge = ({ className }: { className?: string }) => (
  <Badge
    variant="icon"
    icon={<Repeat className="h-3 w-3" />}
    label="Substitute"
    size="sm"
    className={mergeClassNames(
      'shrink-0 gap-1 text-xs text-gray-700',
      className
    )}
  />
);
